<!-- <nb-card >
    <nb-card-header class="title-dialog">
        <button type="button" class="close float-right" size="small" (click)="closeActualizarDebito('')">&times;</button>
        <h3 style="color: white;">Actualizar - Debitos/Pagos</h3>
    </nb-card-header>
    <nb-card-body style="text-align: center;">
        <h3>¿Esta seguro que desea actualizar los datos?</h3>
        <h5>Se perderan todos los datos que no se guardaron</h5>
        <br>
        <div style="float: left;">
            <button nbButton size="small" class="buttontz" (click)="closeActualizarDebito('')">Cancelar</button>
        </div>
        <div style="float: right;">
            <button nbButton size="small"  class="buttontz" (click)="actualizarDebitos()">Guardar</button>
        </div>
    </nb-card-body>
</nb-card> -->

 <!-- <h1 mat-dialog-title>Hi </h1>
 <div mat-dialog-content>
   <p>What's your favorite animal?</p>
   <mat-form-field>
     <mat-label>Favorite Animal</mat-label>
     <input matInput>
   </mat-form-field>
 </div>
 <div mat-dialog-actions>
   <button mat-button >No Thanks</button>
   <button mat-button  cdkFocusInitial>Ok</button>
 </div> -->

 <!-- <h3 style=" color: white;">Actualizar - Debitos/Pagos</h3>
 <h3>¿Esta seguro que desea actualizar los datos?</h3>
 <h5>Se perderan todos los datos que no se guardaron</h5>
 <br>
 <div style="float: left;">
     <button mat-button class="buttontz" (click)="actualizarDebitos(false)"  >Cancelar</button>
 </div>
 <div style="float: right;">
     <button mat-button class="buttontz" (click)="actualizarDebitos(true)">Actualizar</button>
 </div> -->

 <mat-card style="background-color: #007749;"><h3 style=" color: white;">Actualizar - Debitos/Pagos</h3></mat-card>
<mat-card style="height: 150px;">
    <mat-card-content>
        <h3>¿Esta seguro que desea actualizar los datos?</h3>
        <h5>Se perderan todos los datos que no se guardaron</h5>
    </mat-card-content>
    <mat-card-actions>
      <div style="float: left;">
          <button mat-button class="buttontz" (click)="actualizarDebitos(false)">Cancelar</button>
      </div>
      <div style="float: right;">
          <button mat-button class="buttontz" (click)="actualizarDebitos(true)">Actualizar</button>
      </div>
    </mat-card-actions>
</mat-card>